// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CU0M","toggle":"styles_toggle__fdlTX","preview":"styles_preview__1Qwlx"};